<template>
  <div class="page-content">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <h4 class="h4-white">INSS Cooperado</h4>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-between justify-content-md-end"
      >
        <div class="actions actions-dark d-inline-block">
          <a href="#" @click="getPageLista()" class="action-item ml-md-4 text-white btn">
            <i class="oi oi-grid-three-up mr-2"></i>Lista
          </a>
          <a href="#" @click="getPageGrafico()" class="action-item ml-3 text-white btn">
            <i class="oi oi-graph mr-2"></i>Gráfico
          </a>
        </div>
        <a
          href="#"
          @click="getPageCadastro()"
          class="btn"
          data-toggle="tooltip"
          data-placement="top"
          title="Adicionar nova declaração"
        >
          <div class="media align-items-center">
            <span class="btn-avatar rounded-circle btn-white">
              <i class="oi oi-plus"></i>
            </span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeclaracaoInssActions",
  methods: {
    getPageLista: function() {
      this.$router.push("/DeclaracaoInssLista");
    },
    getPageGrafico: function() {
      this.$router.push("/DeclaracaoInssGrafico");
    },
    getPageCadastro: function() {
      this.$router.push("/DeclaracaoInssCadastro");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssActions.vue